<template>
    <v-autocomplete v-model="item" :search-input.sync="searchValue" item-value="_id" :return-object="returnObject" v-bind="{ ...$attrs, items, loading, itemText }" @click="alert" @keyup="onKeyup" @keyup.enter="search" @change="onChange" />
</template>

<script>
import api from "@/api";

export default {
    props: {
        value: { type: [String, Object, Array], default: null },
        returnObject: { type: Boolean, default: false },
    },
    data: () => ({
        item: null,
        items: [],

        searchValue: null,

        loading: false,
    }),
    computed: {
        outOfSync() {
            if (this.returnObject) {
                return (this.value?._id || null) != (this.item?._id || null);
            }
            return this.value != this.item;
        },
        params() {
            const { searchValue } = this;
            return { searchValue };
        },
    },
    mounted() {
        this.sync();
        this.search();
    },
    watch: {
        value() {
            this.sync();
        },
        outOfSync() {
            this.emit();
        },
    },
    methods: {
        sync() {
            if (this.returnObject) {
                this.item = this.value ? { ...this.value } : null;

                if (this.value && !this.items.some(({ _id }) => _id == this.value?._id)) this.search();
            } else {
                this.item = this.value || null;

                if (this.value && !this.items.some(({ _id }) => _id == this.value)) this.search();
            }
        },
        emit() {
            if (this.returnObject) {
                this.$emit("input", this.item ? { ...this.item } : null);
            } else {
                this.$emit("input", this.item);
            }
        },
        async search() {
            this.loading = true;

            try {
                const { params } = this;
                const { authors: items } = await api.console.auction.authors.gets({
                    headers: { limit: 50, sort: JSON.stringify({ "name.ko": 1, createdAt: -1 }) },
                    params,
                });
                this.items = items;

                if (this.item) {
                    const { author: item } = await api.console.auction.authors.get({
                        _id: this.returnObject ? this.item?._id : this.item,
                    });

                    if (item) {
                        const index = this.items.findIndex(({ _id }) => _id == item._id);

                        if (0 <= index) {
                            this.items.splice(index, 1, item);
                        } else {
                            this.items = [item, ...this.items];
                        }
                    }
                }
            } finally {
                this.loading = false;
            }
        },
        itemText({ nameTag }) {
            return nameTag?.ko;
        },
        alert() {
            if (this.$attrs.readonly && this.$attrs.readonlyMessage) alert(this.$attrs.readonlyMessage);
        },
        onKeyup(event) {
            switch (/^Arrow/.test(event.code)) {
                case false: {
                    this.search();
                    break;
                }
            }
        },
        onChange() {
            this.$nextTick(() => this.$emit("emit"));
        },
    },
};
</script>

<style></style>
